var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "core-metrics" },
    [
      _c(
        "Search",
        _vm._g(_vm._b({}, "Search", _vm.filterAttrs, false), _vm.filterEvent)
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "metrics-body",
        },
        [
          _c(
            "div",
            { staticClass: "summary-grid" },
            _vm._l(_vm.summaryList, function (item) {
              return _c(
                "div",
                {
                  key: item.key,
                  staticClass: "summary-card",
                  style: { borderTopColor: item.color },
                },
                [
                  _c("div", { staticClass: "summary-card__title" }, [
                    _vm._v(_vm._s(item.title)),
                  ]),
                  _c("div", { staticClass: "summary-card__amount" }, [
                    _vm._v("¥ " + _vm._s(_vm.formatAmount(item.total))),
                  ]),
                  _c("div", { staticClass: "summary-card__desc" }, [
                    _vm._v(_vm._s(item.desc)),
                  ]),
                ]
              )
            }),
            0
          ),
          _c(
            "div",
            { staticClass: "section" },
            [
              _vm._m(0),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                _vm._l(_vm.channelPanels, function (panel) {
                  return _c(
                    "el-col",
                    { key: panel.key, attrs: { xs: 24, sm: 24, md: 12 } },
                    [
                      _c(
                        "metric-panel",
                        _vm._b({}, "metric-panel", panel, false)
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section" },
            [
              _vm._m(1),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                _vm._l(_vm.merchantPanels, function (panel) {
                  return _c(
                    "el-col",
                    { key: panel.key, attrs: { xs: 24, sm: 24, md: 12 } },
                    [
                      _c(
                        "metric-panel",
                        _vm._b({}, "metric-panel", panel, false)
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section__header" }, [
      _c("h3", [_vm._v("渠道维度")]),
      _c("span", { staticClass: "section__tip" }, [
        _vm._v("按渠道汇总，金额单位：元"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section__header" }, [
      _c("h3", [_vm._v("商户维度")]),
      _c("span", { staticClass: "section__tip" }, [
        _vm._v("按商户汇总（仅已核销券码），金额单位：元"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }